import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface RemoveDislikedMealRequest {
  meal_id: string;
}

export const useRemoveDislikedMeal = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKeys.DISLIKED_MEALS, "remove"],
    mutationFn: async (requestBody: RemoveDislikedMealRequest) => {
      const user = guardGetUserFromLocalStorage();
      return MealsService.removeDislikedMealApiV1MealsDislikedDelete(
        user.id,
        requestBody,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.DISLIKED_MEALS] });
    },
  });

  return {
    removeDislikedMeal: mutation.mutate,
    removeDislikedMealAsync: mutation.mutateAsync,
    isRemovingDislikedMeal: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    response: mutation.data,
  };
};
